import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { chakra } from '@chakra-ui/react';
import Text from '@molecules/Text';
import { DynamicTag } from './DynamicTag';
import { HostileHostStyles } from './HostileHostStyles';
export const ResponsiveBox = chakra('div', {
    baseStyle: {
        fontSize: '32px',
        margin: '20px',
        maxWidth: 'none',
        p: {
            margin: 0,
            padding: 0,
        },
        width: 'auto',
    },
});
const FullWidthWithPixelWidth = ({ bg } = {}) => {
    const containerRef = useRef(null);
    const [widthPx, setWidthPx] = useState(0);
    useEffect(() => {
        // Remove body margin, to allow check the 320px wide page behavior
        document.body.style.margin = '0';
        // Set Viewport Tag to 320px width and disable user scaling
        const viewportTag = document.querySelector('meta[name="viewport"]');
        if (!viewportTag)
            return;
        viewportTag.setAttribute('content', 'width=320, user-scalable=no');
    }, []);
    useEffect(() => {
        const el = containerRef.current;
        if (!el)
            return;
        const update = () => setWidthPx(Math.round(el.getBoundingClientRect().width));
        update();
        const ro = new ResizeObserver(() => update());
        ro.observe(el);
        return () => ro.disconnect();
    }, []);
    return (_jsxs("div", { ref: containerRef, style: {
            backgroundColor: bg || '#f0f0f0',
            border: '1px solid #ccc',
            boxSizing: 'border-box',
            fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif',
            marginBottom: '16px',
            padding: 0,
            width: '100%',
        }, children: ["Width: ", widthPx, "px"] }));
};
export const WebComponentsTestPage = () => {
    return (_jsxs("div", { children: [_jsx(HostileHostStyles, {}), _jsx("h1", { children: "Booking Engine WebComponents" }), window['withdrawConsent'] && (_jsx("button", { onClick: () => { var _a; return (_a = window['withdrawConsent']) === null || _a === void 0 ? void 0 : _a.call(window); }, children: "Renew Cookie Consentment" })), _jsx("div", { style: {
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                }, children: _jsx(FullWidthWithPixelWidth, { bg: "yellow" }) }), _jsxs(ResponsiveBox, { children: [_jsx(Text, { children: "Parent font-size 32px" }), _jsx(FullWidthWithPixelWidth, { bg: "lightgreen" }), _jsx(DynamicTag, { argPairs: [
                            ['property-code', '9X8pzA'],
                            ['environment', 'stage'],
                            ['island', 'us2'],
                        ], tag: "cb-immersive-experience" })] })] }));
};
